// extracted by mini-css-extract-plugin
module.exports = {"button":"AddSectionButton_button__2rQ8D"};